'use strict';
const bubbleRect = require('./bubble-rect');
/* connectors for surrounding borders should go to the bubble visually,
 * but for underlines and overlines need to go around the whole area
 * of the node in the map layout
 */
module.exports = function connectorBox(layoutNode, nodeView) {
	const borderType = nodeView.theme.borderType;
	if (borderType === 'surround') {
		return Object.freeze(
			Object.assign({styles: nodeView.effectiveStyles}, bubbleRect(layoutNode, nodeView))
		);
	} else {
		return Object.freeze({
			top: layoutNode.y,
			left: layoutNode.x,
			width: layoutNode.width,
			height: layoutNode.height,
			styles: nodeView.effectiveStyles
		});
	}
};

